export const MAX_JUSTIFICANTE_BYTES = 5 * 1024 * 1024;
export const TIPOS_JUSTIFICANTE = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];
export const CORREO_COMITE = 'fmds.bad@gmail.com';
export const AVISO_REVISION_COMITE = 'La solicitud de aplazamiento con justificante la revisará el comité.';

// Jornadas con algún partido solicitable, sin repetir, en orden.
export const jornadasDisponibles = (solicitables) => {
  const porJornada = new Map();
  solicitables.forEach((p) => { if (!porJornada.has(p.jornada)) porJornada.set(p.jornada, p.fechaJornada); });
  return [...porJornada].map(([jornada, fechaJornada]) => ({ jornada, fechaJornada })).sort((a, b) => a.jornada - b.jornada);
};

export const partidosDeJornada = (solicitables, jornada) =>
  solicitables.filter((p) => String(p.jornada) === String(jornada));

// "el jugador contrario", "la jugadora contraria" o "el equipo contrario", según la modalidad.
export const textoContrincante = (partido) => {
  if (!partido || partido.esDobles) return 'el equipo contrario';
  return partido.modalidad.toUpperCase().includes('FEMENINO') ? 'la jugadora contraria' : 'el jugador contrario';
};

// Los sets rellenados (puntos de ambos lados) en orden; los vacíos del final se ignoran.
export const construirSets = (filas) => {
  const sets = [];
  for (const [i, f] of filas.entries()) {
    if (f.local === '' && f.visitante === '') continue;
    sets.push({ numero: i + 1, puntosLocal: Number(f.local), puntosVisitante: Number(f.visitante), adjudicado: false });
  }
  return sets;
};

export const validarSets = (sets) => {
  if (sets.length < 2) return 'Indica al menos los dos primeros sets.';
  if (sets.some((s) => !Number.isInteger(s.puntosLocal) || !Number.isInteger(s.puntosVisitante) || s.puntosLocal < 0 || s.puntosVisitante < 0)) {
    return 'Los puntos deben ser números enteros, sin negativos.';
  }
  if (sets.some((s) => s.puntosLocal === s.puntosVisitante)) return 'Un set no puede acabar en empate.';
  return null;
};

export const validarArchivo = (archivo) => {
  if (!archivo) return 'Adjunta el justificante.';
  if (!TIPOS_JUSTIFICANTE.includes(archivo.type)) return 'Solo se admite PDF o imagen (JPG, PNG o WebP).';
  if (archivo.size > MAX_JUSTIFICANTE_BYTES) return 'El justificante pesa más de 5 MB.';
  return null;
};

export const archivoABase64 = (archivo) =>
  new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onload = () => resolve(String(lector.result).split(',')[1] ?? '');
    lector.onerror = () => reject(new Error('No se pudo leer el archivo.'));
    lector.readAsDataURL(archivo);
  });
